import { connect } from 'react-redux';
import isoLanguages from '@cospired/i18n-iso-languages';
import isoLanguagesEn from '@cospired/i18n-iso-languages/langs/en.json';
import { ReduxState } from '../../../../../../ReduxStorage/state';
import { Filter } from '.';
import { SelectorOption } from '../../../../../components/Forms/Selector/types';
// TODO: move these out of the legacy CoursesPage
import {
  selectCategoryOptions,
  selectCategoryValues,
  selectFeaturedInstitutions,
  selectInstitutionValues,
  selectFeeTypeValues,
  selectCourseTypeValues,
  selectCourseSectorValues,
  selectCourseLanguageValues,
} from '../../../selectors';
import { updateFilters } from '../../../dispatchers';
import {
  stringToFeeType,
  stringToCourseType,
  stringToCourseSector,
} from '../../../types';
import { makeMetricsLogEvent } from '../../../../../../ReduxStorage/Metrics/manualEventDispatchers';

isoLanguages.registerLocale(isoLanguagesEn);

const languageOptions: SelectorOption[] = Object.entries(
  isoLanguages.getNames('en')
)
  .map(([key, value]) => ({
    value: key,
    label: value,
  }))
  .sort((a, b) => (a.label > b.label ? 1 : -1));

const feeTypeOptions: SelectorOption[] = [
  {
    label: 'Free',
    value: 'free',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
];

const courseTypeOptions: SelectorOption[] = [
  {
    label: 'Short course',
    value: 'SHORT_COURSE',
  },
  {
    label: 'OpenCred',
    value: 'OPENCRED',
  },
  {
    label: 'Qualification',
    value: 'QUALIFICATION',
  },
];

const courseSectorOptions: SelectorOption[] = [
  {
    label: 'Higher education',
    value: 'highereducation',
  },
  {
    label: 'Vocational education',
    value: 'VOCATIONAL_EDUCATION',
  },
  {
    label: 'K-12',
    value: 'K_12',
  },
  {
    label: 'Professional Learning',
    value: 'professionaldevelopment',
  },
  {
    label: 'Lifestyle',
    value: 'lifestyle',
  },
];

const FILTER_LOCATION = 'course listing page';
const FILTER_EVENT_NAME = 'CourseDiscoveryFilter-Applied';

export const ConnectedTopicsFilter = connect(
  (state: ReduxState) => ({
    options: selectCategoryOptions(state),
    values: selectCategoryValues(state),
    header: 'Topic areas',
    name: 'categories',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          categories: values && values.length ? values : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'topics',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);

export const ConnectedInstitutionsFilter = connect(
  (state: ReduxState) => ({
    options: selectFeaturedInstitutions(state),
    values: selectInstitutionValues(state),
    header: 'Institutions',
    name: 'institutions',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          institutions: values && values.length ? values : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'institutions',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);

export const ConnectedFeeTypeFilter = connect(
  (state: ReduxState) => ({
    options: feeTypeOptions,
    values: selectFeeTypeValues(state),
    header: 'Enrolment types',
    name: 'feeTypes',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          feeTypes:
            values && values.length ? values.map(stringToFeeType) : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'feeTypes',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);

export const ConnectedCourseTypesFilter = connect(
  (state: ReduxState) => ({
    options: courseTypeOptions,
    values: selectCourseTypeValues(state),
    header: 'Course types',
    name: 'courseTypes',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          courseTypes:
            values && values.length
              ? values.map(stringToCourseType)
              : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'courseTypes',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);

export const ConnectedCourseSectorsFilter = connect(
  (state: ReduxState) => ({
    options: courseSectorOptions,
    values: selectCourseSectorValues(state),
    name: 'courseSectors',
    header: 'Course sectors',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          courseSectors:
            values && values.length
              ? values.map(stringToCourseSector)
              : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'courseSectors',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);

export const ConnectedCourseLanguagesFilter = connect(
  (state: ReduxState) => ({
    options: languageOptions,
    values: selectCourseLanguageValues(state),
    name: 'language',
    header: 'Language',
  }),
  (dispatch) => ({
    onChange: (values: string[]) => {
      dispatch(
        updateFilters({
          languages: values && values.length ? values : undefined,
        })
      );
      dispatch(
        makeMetricsLogEvent(FILTER_EVENT_NAME, {
          filterLocation: FILTER_LOCATION,
          selectedFilterGroup: 'languages',
          selectedFilterValue: values,
        })
      );
    },
  })
)(Filter);
